import useTheme from 'hooks/useTheme'
import { Flex, Text } from 'vvs-uikit'
import { CloseButton } from 'components/CloseButton'
import styled from 'styled-components'
import { isAfter } from 'date-fns'

export const storageKey = 'maintenance-20230511'

export const isExpired = () => {
  const now = new Date()
  const end = new Date('2023-05-11T08:00:00.000Z')
  return isAfter(now, end)
}

export const MaintenanceBanner = ({ onCloseClick }) => {
  const { theme } = useTheme()

  return (
    <StyledCard background="white">
      <Flex flex="1" flexDirection="row" alignItems="center" pl="40px" pr="20px" py="20px" height="100%">
        <Flex flexDirection="column" alignItems="start">
          <Text fontWeight={600} color={theme.colors.darkBlue}>
            VVS will be under website maintenance on 11th-May, 05:00-08:00 UTC.
          </Text>
          <Text fontSize="12px" fontWeight={600} color={theme.colors.darkBlue}>
            Our website will not be available during the maintenance. Funds are secured, and our website service will be
            resumed once the maintenance is completed. Thank you.
          </Text>
        </Flex>
      </Flex>
      <Flex mx={2}>
        <CloseButton onClick={onCloseClick} />
      </Flex>
    </StyledCard>
  )
}

const StyledCard = styled(Flex)`
  border-radius: ${({ theme }) => theme.radii.card};
  width: 100%;
  padding: 0px;
  height: fit-content;
  max-width: 1200px;

  position: relative;
`
